import { bind, wire } from 'hyperhtml';

import { RenderController } from '../base';
import TeachersSelect from '../../wires/TeachersSelect';

interface TeacherInfo {
  id: number;
  displayNameZh: string;
  profileImageUrlSquare: string;
  isInactive: boolean;
}

interface State {
  allTeachers: TeacherInfo[];
  selectedTeacherIdsMap: { [key: string]: number };
  curFormIndex: number;
}

export default class RegularTeachersFormController extends RenderController {
  static targets = ['teachers', 'selectPicker'];

  teachersTarget: HTMLElement;
  selectPickerTargets: HTMLSelectElement[];

  state: State = {
    selectedTeacherIdsMap: {},
    allTeachers: [],
    curFormIndex: 0,
  };

  connect() {
    const allTeachers = JSON.parse(this.data.get('allTeachers'));
    const selectedTeacherIdsMap: { [key: string]: number } = {};
    const selectedTeacherIds: number[] = JSON.parse(this.data.get('selectedTeacherIds'));
    selectedTeacherIds.forEach((elm, index) => {
      selectedTeacherIdsMap[index] = elm;
    });
    const curFormIndex = Object.keys(selectedTeacherIdsMap).length;
    this.setState({ allTeachers, selectedTeacherIdsMap, curFormIndex });
  }

  get selectedTeacherIds() {
    return Object.values(this.state.selectedTeacherIdsMap);
  }

  get nextAvailableTeacherId() {
    return this.state.allTeachers
      .map(teacher => teacher.id)
      .find(id => this.selectedTeacherIds.indexOf(id) === -1);
  }

  onAddTeacher() {
    const selectedTeacherIdsMap = { ...this.state.selectedTeacherIdsMap };
    selectedTeacherIdsMap[this.state.curFormIndex] = this.nextAvailableTeacherId;
    this.setState({
      selectedTeacherIdsMap,
      curFormIndex: this.state.curFormIndex + 1,
    });
    this.dispatch('CHANGE_REGULAR_TEACHERS', this.selectedTeacherIds);
  }

  onDeleteTeacher(formIndex: string | number) {
    const selectedTeacherIdsMap = { ...this.state.selectedTeacherIdsMap };
    delete selectedTeacherIdsMap[formIndex];
    this.setState({ selectedTeacherIdsMap });
    this.dispatch('CHANGE_REGULAR_TEACHERS', this.selectedTeacherIds);
  }

  onSelectTeacher = (teacherId: number, formIndex: string | number) => {
    const selectedTeacherIdsMap = { ...this.state.selectedTeacherIdsMap };
    selectedTeacherIdsMap[formIndex] = teacherId;
    this.setState({ selectedTeacherIdsMap });
    this.dispatch('CHANGE_REGULAR_TEACHERS', this.selectedTeacherIds);
  }

  renderSelect(formIndex: string | number, selectedTeacherId: number) {
    const teachers = this.state.allTeachers.filter(teacher => (
      this.selectedTeacherIds.indexOf(teacher.id) === -1 || selectedTeacherId === teacher.id
    ));
    return TeachersSelect({
      teachers,
      selectedId: selectedTeacherId,
      onChange: evt => this.onSelectTeacher(parseInt(evt.currentTarget.value, 10), formIndex),
      name: `teacher_list-${formIndex}-teacher`,
      target: 'components--regularTeachersForm.selectPicker',
    });
  }

  render() {
    const formIndices = Object.keys(this.state.selectedTeacherIdsMap);
    const teachers = formIndices.map((formIndex) => {
      const teacherId = this.state.selectedTeacherIdsMap[formIndex];
      return wire()`
        <div class="form-group">
          <div class="row admin teacher_select">
            <div class="col-10">
              ${this.renderSelect(formIndex, teacherId)}
            </div>
            <div class="col-2">
              <button
                onClick=${() => this.onDeleteTeacher(formIndex)}
                data-form-index="${formIndex}"
                type="button"
                class="btn btn-danger"
              >
                <i class="fa fa-minus-circle"></i>
              </button>
            </div>
          </div>
        </div>
      `;
    });
    bind(this.teachersTarget)`${teachers}`;
    ($(this.selectPickerTargets) as any).selectpicker('render');
  }
}
